import axios from "axios";

export const state = {
    patientreferrals: [],
};

export const getters = {
    patientreferrals: state => state.patientreferrals,
};

export const mutations = {
    setReferrals(state, newValue) {
        state.patientreferrals = newValue
    },
};

export const actions = {
    fetchPatientReferrals({ commit }) {
        axios.get('/patientreferrals').then(res => {
            commit('setReferrals', res.data.referrals)
        })
    },
};
